import {
  RepositorioBase,
} from "@/http"
import { ResultadoApiGET } from "@/types/api"
import {
  CalendariosParams,
  CriarCalendarioDaAtividade,
  EditarCalendarioDaAtividade,
  ListarCalendariosDasAtividades,
} from "./calendarios.modelos"

class CalendariosDasAtividadesRepositorio extends RepositorioBase {
  public criarCalendarioDaAtividade = (
    calendarioDaAtividade?: CriarCalendarioDaAtividade
  ): Promise<{ id: string }> =>
    this.instance.post("/api/calendarios-das-atividades", calendarioDaAtividade)

  public deletarCalendarioDaAtividade = (
    id?: string
  ): Promise<{ id: string}> =>
    this.instance.delete(`/api/calendarios-das-atividades/${id}`)

  public listarCalendariosDaAtividade = (
    params?: CalendariosParams
  ): Promise<ResultadoApiGET<ListarCalendariosDasAtividades>> =>
    this.instance.get("/api/calendarios-das-atividades", { params })

  public editarCalendariosDasAtividades = (
    id?: string,
    calendarioDaAtividade?: EditarCalendarioDaAtividade
  ): Promise<{ id: string }> =>
    this.instance.patch(`/api/calendarios-das-atividades/${id}`, calendarioDaAtividade)
}

export default CalendariosDasAtividadesRepositorio
